export class ProblemDashboardModel {
  problemId: number;
  problemCode: string;
  placeName: string;
  itemId: string;
  problemDate: string;
  itemName: string;
  statusId: number;
  status: string;
  suffixId: number;
  priorityId: number;
  priority: string;
  riskId: number;
  risk: string;
  riskCode: string;
  itemType: string;
  isPeaAvaliable: string;
  reportDetails: string;
  activeRowFlag: string;
  color: string;
  availablity: string;
  delayId: string;
  deliveryUnit: string;
  sectionManager: string;
  team: string;
}
export class ProblemNotesGetModel {
  notesId: number;
  problemId: number;
  assignmentId: number;
  peaId: number;
  notes: string;
  notesTypeId: number;
  notesType: string;
  notesCategoryId: number;
  notesCategory: string;
  mailTo: string;
  mailCc: string;
  subject: string;
  createdDate: string;
  created: string;
  createdBy: string;
  linkId: number;
  modified: string;
  postEventActionId: number;
  userRole: string;
  reason: string;
  estimatedTrackAccess: string;
}

export class ProblemGetModel {
  problemId: number;
  problemNo: number;
  incidentId: number;
  problemTitle: string;
  problemCode: string;
  problemTypeId: number;
  problemType: string;
  ifcId: number;
  ifcName: string;
  isEmployee: boolean;
  peopleId: string;
  reportedBy: string;
  phoneNo: string;
  isSignalBox: boolean;
  signalBoxName: string;
  sourceTypeId: number;
  sourceTypeName: string;
  email: string;
  reporterTypeId: number;
  reporterTypeName: string;
  contractingCompanyId: number;
  contractingCompanyName: string;
  operatingCompanyId: number;
  operatingCompanyName: string;
  reportCategoryId: number;
  reportCategory: string;
  problemDate: string;
  ticketReferenceNumber: string;
  ticketRefSystemId: number;
  ticketRefSystem: string;
  problemDescription: string;
  severityId: number;
  severity: string;
  severityCode: string;
  priorityId: number;
  priority: string;
  priorityReasonId: number;
  ratingsId: number;
  blobId: number;
  statusId: number;
  status: string;
  cancellationTypeId: number;
  cancellationType: string;
  incidentTypeId: number;
  incidentType: string;
  cancellationComments: string;
  riskId: number;
  risk: string;
  riskCode: string;
  riskReasonId: number;
  riskReason: string;
  isPEAAvailable: string;
  postEventAnalysisId: number;
  peaCode: string;
  peaStatusId: number;
  peaStatus: string;
  actionSummary: string;
  causeSummary: string;
  causeId: number;
  problemTotalityId: number;
  problemTotality: string;
  special1: string;
  special2: string;
  coaIndicator: boolean | string;
  spadIndicator: boolean | string;
  trainOperatingCompany: string;
  createdDate: string;
  createdBy: string;
  created: string;
  modifiedBy: string;
  modified: string;
  modifiedDate: string;
  isActive: boolean;
  isDelete: boolean;
  symptom: string;
  reportedDate: string;
  openDate: string;
  dueDate: string;
  closeDate: string;
  codedDate: string;
  closureState: string;
  causeDescription: string;
  causeCode: string;
  isExternal: boolean;
  partyId: number;
  partyType: string;
  familyName: string;
  givenName: string;
  trainNo: string;
  defectId: number;
  defect: string;
  subStatusId: number;
  subStatus: string;
  assignmentId: number;
  attachmentId: number;
  ccil: string;
  problemRating: number;
  locationRating: number;
  incidentRating: number;
  imsNo: number;
  peaId: number;
  isMonitoringRequired: string;
  peaLastSignoffDate: string;
  categoryId: number;
  categoryName: string;
  attributeId: number;
  attributeName: string;
  locomotiveNo: string;
  vehicleId: number;
  awsCode: string;
  assignments: AssignmentGetModel[];
  rating: RatingGetModel;
  trustIncidents: TrustIncidentGetModel[];
  problemLink: RelationshipGetModel[];
  notes: NotesGetModel[];
}
export class AssignmentGetModel {
  assignmentId: number;
  linkId: number;
  placeId: number;
  placeName: string;
  itemId: string;
  description: string;
  elrRef: string;
  isPrimaryItem: string;
  isUnverifiedItem: string;
  isNotApplicableItem: string;
  itemType: string;
  suffixId: number;
  suffix: string;
  discipline: string;
  maintOrgUnitId: number;
  startYardage: number;
  endYardage: number;
  symptomId: number;
  symptomName: string;
  bridgeId: number;
  bridgeName: string;
  problemTotalityId: number;
  problemTotalityName: string;
  problemQuestId: number;
  special1: string;
  special2: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  locationId: number;
  locationName: string;
  uaNaComments: string;
  statusId: number;
  statusName: string;
  subStatusId: number;
  subStatusName: string;
  inActiveComments: string;
  isGoldenItem: string;
  createdBy: string;
  created: string;
  createdDate: string;
  modifiedBy: string;
  modified: string;
  modifiedDate: string;
  isActive: string;
  isDelete: string;
  itemNo: string;
  personId: string;
  teamAllocatedDate: string;
  teamReAllocatedDate: string;
  teamId: string;
  teamName: string;
  sectionMangerId: string;
  sectionManger: string;
  assignmentDiscipline: string;
  deliveryUnit: string;
  deliveryUnitId: string;
  assignmentType: number;
  assignmentTypeName: string;
  advisedName: string;
  advisedContactDetail: string;

  trackId?: string;
  egi?: string;
  equipmentDescription?: string;
  equipmentStatus?: string;
  itemClass?: string;
  localName?: string;
  teamAttendance: TeamAttendanceGetModel;
  additionalFields: AdditionalFieldsGetModel[];
  team: string;
  startMileage: number;
  endMileage: number;
  startYardageLimit?: number;
  endYardageLimit?: number;
}
export class TeamAttendanceGetModel {
  teamAttendanceId: number;
  placeId: number;
  placeName: string;
  disId: number;
  disName: string;
  teamId: string;
  teamName: string;
  personId: number;
  personName: string;
  attendOrgUnitId: number;
  tfcRaisedStatusId: string;
  activeStatusId: string;
  teamListStatus: number;
  createdDate: string;
  modifiedDate: string;
  teamAllocatedDateTime: string;
  eta: string;
  arrivalSiteDateTime: string;
  advisedDateTime: string;
  availableDateTime: string;
  commencedDateTime: string;
  completedDateTime: string;
  reAllocatedDateTime: string;
}
export class AdditionalFieldsGetModel {
  id: number;
  workId: number;
  fieldId: number;
  fieldValueId: number;
  fieldValue: string;
}
export class RatingGetModel {
  ratingsId: number;
  problemRating: number;
  locationRating: number;
  incidentRating: number;
}
export class TrustIncidentGetModel {
  problemId: number;
  trustIncidentId: number;
  delayDescription: string;
  trustId: number;
  delay: number;
  createdBy: string;
  created: string;
  createdDate: string;
  modifiedBy: string;
  modified: string;
  modifiedDate: string;
}
export class RelationshipGetModel {
  problemId: number;
  problemCode: string;
  problemDetails: string;
  problemDate: string;
  problemLinkId: number;
  reportedBy: string;
  priority: string;
  status: string;
  relationship: string;
  createdBy: string;
  created: string;
  createdDate: string;
  modifiedBy: string;
  modified: string;
  modifiedDate: string;
  subStatus: string;
}
export class NotesGetModel {
  notesId: number;
  problemId: number;
  assignmentId: number;
  peaId: number;
  notes: string;
  notesTypeId: number;
  notesType: string;
  notesCategoryId: number;
  notesCategory: string;
  mailTo: string;
  mailCc: string;
  subject: string;
  createdBy: string;
  created: string;
  createdDate: string;
  modifiedBy: string;
  modified: string;
  modifiedDate: string;
}
export class ProblemPostModel {
  emailType: string;
  listOfEmails: string;
  problemId: number;
  recordTypeId: number;
  problemType: string;
  incidentTypeId: number;
  incidentType: string;
  mode: number;
  ifcId: number;
  ifcName: string;
  oldProblemId: number;
  problemCode: string;
  description: string;
  riskId: number;
  risk: string;
  problemNo: number;
  occuredDate: string;
  assignmentId: number;
  priorityId: number;
  priority: string;
  attachmentId: number;
  statusId: number;
  subStatusId: number;
  subStatus: string;
  cancellationTypeId: number;
  cancellationComments: string;
  title: string;
  coaIndicator: string;
  causeId: number;
  defectId: number;
  closureSubStateId: number;
  resolvedDate: string;
  codedDate: string;
  incidentId: number;
  createdBy: string;
  created: string;
  modifiedBy: string;
  modified: string;
  problemTotalityId: number;
  ccilNo: string;
  actionSummary: string;
  spadIndicator: string;
  causeSummary: string;
  ticketRefId: number;
  problemRating: number;
  locationRating: number;
  incidentRating: number;
  ticketRef: string;
  priorityReasonId: number;
  riskReasonId: number;
  closedById: string;
  closedBy: string;
  closedDate: string;
  imsNo: number;
  isMonitoringRequired: string;
  categoryId: number;
  attributeId: number;
  trainNo: string;
  locomotiveNo: string;
  vehicleId: string;
  awsCode: string;
  trsutIncidentIds: string;
  reOpenReasonId: number;

  problemLocation: LocationPostModel;
  problemReporting: ReportingPostModel;
  problemAssignments: AssignmentPostModel[];
}
export class LocationPostModel {
  byLinearRange: { fromPosn: number; toPosn: number; elr: string; }
}
export class ReportingPostModel {
  sourceTypeId: number;
  categoryId: number;
  operatingCompanyId: number;
  operatingCompanyName: string;
  contractingCompanyId: number;
  contractingCompanyName: string;
  issignalbox: string;
  signalboxname: string;
  party: {
    orgUnit: { maintenanceDeliveryUnit: string; workGroupSet: string; workGroup: string; }
    person: { isEmployee: string; personId: string; personName: string; }
  }
  partyTelecomChanel: { mobile: string; email: string; }
}
export class AssignmentPostModel {
  assignmentId: number;
  linkId: number;
  item: {
    itemCore: {
      itemId: string;
      description: string;
      placeId: number;
      placeName: string;
      elrRef: string;
      symptomId: number;
      symptomName: string;
      discipline: string;
      suffixId: number;
      suffix: string;
      itemType: string;
      isPrimaryItem: string;
      isUnverifiedItem: string;
      isGoldenItem: string;
      isNotApplicableItem: string;
      uaNaComments: string;
    };
    itemLocators: {
      byLinearRange: { fromPosn: number; toPosn: number; elr: string; }
    }
  }
  party: {
    orgUnit: {
      maintenanceDeliveryUnit: string;
      workGroupSetId?: string;
      workGroupSet?: string;
      workGroupId?: string;
      workGroup?: string;
    }
    person: { isEmployee: string; personId: string; personName: string; }
  }
  statusId: number;
  subStatusId: number;
  isItemChanged: string;
  isActive: string;
  inActiveComments: string;
  itemComments: string;
  assignmentDiscipline: string;
  assignmentType?: number;
  advisedName?: string;
  advisedContactDetail?: string;
}

export class SearchProblemCodeModel {
  problemId: number;
  problemCode: string;
  placeName: string;
  itemId: string;
  problemDate: string;
  itemName: string;
  statusId: number;
  status: string;
  suffixId: number;
  priorityId: number;
  priority: string;
  riskId: number;
  risk: string;
  riskCode: string;
  itemType: string;
  isPeaAvaliable: string;
  reportDetails: string;
  activeRowFlag: string;
  color: string;
  availablity: string;
  delayId: string;
  deliveryUnit: string;
  sectionManager: string;
  team: string;
  deliveryUnitCode: string;
  sectionManagerCode: string;
  subStatus: string;
  trustDetails: string;
  problemDetails: string;
}
export class ProblemSummaryModel {
  placeId: number;
  elrId: string;
  startMileage: number;
  endMileage: number;
  startYardage: number;
  endYardage: number;
  itemId: string;
  linkId: number;
  problemNo: number;
  priorityId: number;
  priorityStatusId: number;
  problemType: string;
  problemDesc: string;
  problemRiskCode: string;
  placeName: string;
  disciplineName: string;
  problemStatus: string;
  problemRiskName: string;
  problemCode: string;
  itemDescription: string;
  priorityStatusName: string;
  symptomName: string;
  problemId: number;
  created?: string;
  createdBy: string;
  createdDate: string;
  elrName: string;
  itemType:string;
}
export class ProblemGobalSearch {
  problemId: number;
  problemCode: string;
  placeName: string;
  itemId: number;
  problemDate: string;
  itemName: string;
  statusId: number;
  status: string;
  suffixId: number;
  priorityId: number;
  priority: string;
  riskId: number;
  risk: string;
  riskCode: string;
  itemType: string;
  isPeaAvaliable: string;
  reportDetails: string;
  activeRowFlag: string;
  color: string;
  availablity: string;
  delayId: string;
  deliveryUnit: string;
  sectionManager: string;
  team: string;
  deliveryUnitCode: string;
  sectionManagerCode: string;
  subStatus: string;
  trustDetails: string;
  createDate: string;
}
export class GlobalSearch {
  fieldName: string;
  fieldValue: string;
  recordType: string;
  ifcId: number;
}